<template>
    <el-row>
        <el-row>
            <el-input placeholder="请输入会员id" type="number" style="width: 200px;margin-right: 10px;" v-model="personId" />
            <el-input placeholder="请输入会员昵称" style="width: 200px;margin-right: 10px;" v-model="userName" />
            <el-button @click="demand" type="primary">筛选</el-button>
            <el-button @click="Export">导出excel</el-button>
            <el-button @click="zhikong">置空</el-button>、
        </el-row>
        <el-table :data="tableData">
            <el-table-column label="序号" prop='id'></el-table-column>
            <el-table-column label="头像">
                <template slot-scope="scope">
                    <el-image :src="scope.row.wxIcon" style="width: 50px;height: 50px;"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="昵称" prop="userName"></el-table-column>
            <el-table-column label="用户id" prop="personId"></el-table-column>
            <el-table-column label="用户等级" prop="levelName"></el-table-column>
            <el-table-column label="心得内容" prop="experienceContent"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    {{ scope.row.scenarioEnable == 1 ? '下架' : '上架' }}
                </template>
            </el-table-column>
            <el-table-column label="发布时间" prop="createTime"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="isStatus(scope.row)">
                        {{ scope.row.scenarioEnable == 0 ? '下架' : '上架' }}
                    </el-button>
                    <!-- <el-button type="text" @click="del(scope.row)">
						删除
					</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 20px 30%;">
            <el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
                :page-size="pageSize" :page-sizes="[30, 50, 100]" :total="total" :current-page.sync="pageNum"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
    </el-row>
</template>

<script>
export default {
    data() {
        return {
            personId: "",
            userName: "",
            pageNum: 1,
            pageSize: 30,
            total: 0,
            tableData: [],
        }
    },
    methods: {
        //查询
        demand() {
            this.getInfo()
        },
        zhikong() {
            this.personId = ""
            this.userName = ""
            this.pageNum = 1
            this.getInfo()
        },
        //导出
        Export() {
            this.$http.post('/api/statistics/knowledgeBase/exportExperience', {
                "personId": this.personId, //人员ID
                "userName": this.userName,
                "scenarioId": this.$route.query.id
            }, {
                responseType: 'blob'
            }).then(res => {
                this.$message({
                    type: 'info',
                    message: '正在导出表格'
                });
                const link = document.createElement('a');
                let blob = new Blob([res.data], {
                    type: 'application/vnd.ms-excel'
                });
                link.style.display = 'none';
                //设置连接
                link.href = URL.createObjectURL(blob);
                link.download = '心得列表';
                document.body.appendChild(link);
                //模拟点击事件
                link.click();
                window.URL.revokeObjectURL(link.href);
                link.remove();
            })
        },
        isStatus(row) {
            let name = ''
            if (row.scenarioEnable == 0) {
                name = '下架'
            } else {
                name = '上架'
            }
            this.$http.post('/api/plant/positions/updateExperience', {
                "id": row.id,
                "scenarioEnable": row.scenarioEnable == 0 ? 1 : 0
            }).then(res => {
                if (res.data.status == 0) {
                    this.$message.success(name + '成功')
                    this.getInfo()
                } else {
                    this.$message.error(name + '失败')
                }
            })
        },
        del(row) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/plant/positions/selectExperience', {
                    "deleteStatus": 1,
                    "id": row.id
                }).then(res => {
                    if (res.data.status == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getInfo()
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败'
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        //查询列表
        getInfo() {
            this.$http.post('/api/plant/positions/selectExperience', {
                "personId": this.personId,
                "scenarioId": this.$route.query.id,
                "userName": this.userName,
                "pageNum": this.pageNum,
                "pageSize": this.pageSize
            }).then(res => {
                this.tableData = res.data.data.list
                this.total = res.data.data.total
            })
        },
        //条数发生变化
        handleSizeChange(val) {
            this.pageNum = 1;
            this.pageSize = val;
            this.getInfo()
        },
        //页数
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getInfo()
        },
    },
    created() {
        this.getInfo()
    }
}
</script>

<style></style>